module.exports = __webpack_public_path__ + "static/media/sf_2000.3ca8163f17ea033c49665d87e7813191.png";